import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'react-oidc-context';

import { config } from '../../../../config/config';
import { Loader } from '../../../shared/components/loader/loader';
import { TitledSection } from '../../../shared/components/titled-section/titled-section';
import { exists } from '../../../shared/utils/filters';
import { SessionsTable } from '../../components/sessions-table/sessions-table';
import { useActiveSessionsQuery } from '../../queries/sessions.graphql';

export const Sessions: FunctionComponent = () => {
    const auth = useAuth();
    const userProfileId = auth.user?.profile.user_profile_id as string;

    const [{ data, fetching }] = useActiveSessionsQuery({
        pause: !userProfileId,
        variables: {
            userProfileId,
            xTenantId: config.TENANT_ID,
        },
    });

    const sessionInformation = useMemo(
        () => data?.sessions?.filter(exists) ?? [],
        [data?.sessions],
    );

    if (fetching) {
        return <Loader />;
    }

    return (
        <TitledSection
            title={<FormattedMessage id="sessions.title" defaultMessage="Sessions" />}
            description={
                <FormattedMessage
                    id="sessions.description"
                    defaultMessage="This is a list of all your active sessions."
                />
            }
        >
            <SessionsTable sessions={sessionInformation} />
        </TitledSection>
    );
};
